import React, {Component} from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';

class ProxiesPagination extends Component {


    _handleOnPageChange = (pagination) => {
        const pageIndex = pagination.selected
        this.props.onChangePage(pageIndex+1);
    }

    render() {
        const {maxPage, page} = this.props.paginationInfo;
        return (
            <div className="event-pagination">

                <ReactPaginate
                    forcePage={page-1}
                    pageCount={maxPage}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={1}
                    onPageChange={this._handleOnPageChange}
                    disableInitialCallback
                    containerClassName={"pagination"}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="Previous page-item"
                    nextClassName="Next page-item"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    breakClassName="page-link"
                />
            </div>
        )
    }
}

ProxiesPagination.propTypes = {
    paginationInfo: PropTypes.object.isRequired,
    onChangePage: PropTypes.func.isRequired,
}

export default ProxiesPagination;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/ProxiesPagination.js